import React, {Component} from "react";
import {Row} from "react-bootstrap";
import Footer from "../Footer/Footer";
import {API} from "../../lib/API";
import localStorage from "../../lib/localStorage";
import {withTranslation} from "react-i18next";
import KnoaToggle from "../Common/KnoaToggle";
import {notifyWithMessage} from "../../lib/notifications/notifyWithMessage";
import ReactTableWrapperTaskmining from "../Table/ReactTableWrapperTaskmining";

class UrlsContainer extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderEditable = this.renderEditable.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.updateCurrentMapping = this.updateCurrentMapping.bind(this);

        this.state = {
            currentMapping: JSON.parse(JSON.stringify(this.props.allMappings)),
            editMode: false,
            formErrors: {}
        }
    }

    updateCurrentMapping(id, property, value) {
        let _currentMapping = JSON.parse(JSON.stringify(this.state.currentMapping));
        for(const key in _currentMapping) {
            if(_currentMapping[key].id===id) {
                _currentMapping[key][property] = value;

                if(JSON.stringify(_currentMapping[key][property]) !== JSON.stringify(this.state.currentMapping[key][property])) {
                    this.setState({currentMapping: _currentMapping})
                }

                break;
            }
        }
    }

    handleEdit(evt) {
        let _value = evt.target.checked;
        if(_value !== undefined) {
            this.setState({
                editMode: _value
            });
        }
    }

    renderEditable(cellInfo) {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const _data = e.target.id.split(":");
                    const _id = parseInt(_data[0]);
                    const _property = _data[1];
                    const _value = e.target.innerHTML;
                    this.updateCurrentMapping(_id, _property, _value)
                }}
                dangerouslySetInnerHTML={{
                    __html: cellInfo.value.props.children
                }}
                id={cellInfo.value.props.id}
            />
        );
    }

    handleToggleChange(evt, idVal) {
        let _value = evt.target.checked;
        if(_value !== undefined) {
            const _data = idVal.split(":");
            const _id = parseInt(_data[0]);
            const _property = _data[1];
            this.updateCurrentMapping(_id, _property, _value)
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const _this = this;
        this.setState({fetchInProgress: "true"});

        const mappingToSave = {
            mappings: this.state.currentMapping
        };

        API.admin
        .post(`/admin/gtm/configuration/app/mapping`, mappingToSave)
        .then(resp => {
            const {data: resData} = resp;
            let inSupport = resData ? resData.inSupport : false;
            notifyWithMessage({type: "success", t: _this.props.t, operation: 'gtmSaved', parameter: null, inSupport});
            //console.log(`configuration saved! \n` + JSON.stringify(_this.state.currentMapping));
            console.log("configuration saved!");
            _this.setState({fetchInProgress: localStorage.get("isLoading")});
            _this.props.updateAllMappings(_this.state.currentMapping);
        })
        .catch(e => {
            console.error(e);
            _this.setState({fetchInProgress: localStorage.get("isLoading")});
            if(localStorage.get("accessDenied401") === "true"){
                _this.setState({showLoggedoutModal:true});
                return;
            }

            let resultCode = -1;
            if(e.data) {
                resultCode = e.data.resultCode;
            }
            if (e.status === 401 || resultCode === 6007)
                window.location.href = "/#/auth/logout";

            if (resultCode > -1) {
                notifyWithMessage({type: 'error', t: this.props.t, resultCode, isNormal: true});
            } else {
                notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
            }
        });
    }

    render() {
        const {t} = this.props;
        const defaultPageSize = this.state.currentMapping.length === 0 ? 5 : 50;
        const footerObj = [];
        const updatePreferencesObj = {
            name: t("common:save"),
            callback: this.handleSubmit,
            disabled: JSON.stringify(this.state.currentMapping) === JSON.stringify(this.props.allMappings)
        };
        footerObj.push(updatePreferencesObj);

        return (
            <>
            <div className="card knoa-main-content">
                <div className="content">
                    <div className="Bar-btn-container">
                        <label id="editSwitch"
                               className="switchLabel"
                               htmlFor="editMode"
                        >
                            {"Edit"}
                        </label>
                        <KnoaToggle Name="editMode"
                                    onChange={this.handleEdit}
                                    value={this.state.editMode}
                                    labelId={"editSwitch"}
                                    onText={t('common:ON')}
                                    offText={t('common:OFF')}
                        />
                    </div>
                    <form onSubmit={this.handleSubmit} noValidate>
                        <div className="panel-body">
                            <Row className="users-table-header">
                                <h4 className="card-title">{this.props.title}</h4>
                            </Row>
                            <Row className="users-table-header">
                                <span className="knoaCardCategory">{t('gtm:titleStatsOf1')}
                                    <span style={{color:'red'}}>{this.props.discovered}</span>
                                    {t('gtm:titleStatsOf2')}
                                    <span style={{color:'red'}}>{this.state.currentMapping.length.toString()}</span>
                                    {t('gtm:titleStatsOf3')}
                                </span>
                            </Row>
                            <div className="knoa-region" tabIndex={"-1"}>
                                <ReactTableWrapperTaskmining
                                    dataTable={this.state.currentMapping}
                                    t={t}
                                    handleToggleChange={this.handleToggleChange}
                                    updateCurrentMapping={this.updateCurrentMapping}
                                    editMode={this.state.editMode}
                                    defaultPageSize={defaultPageSize}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Footer fluid footerObj={footerObj}/>
            </>
        );
    }
}

export default withTranslation()(UrlsContainer);